var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"border":"","columns":_vm.columns1,"data":_vm.showData.list}}),_vm._v(" "),_c('div',{staticClass:"page-con"},[_c('Page',{staticClass:"pull-right",attrs:{"show-total":"","total":_vm.showData.total,"page-size":10,"current":_vm.showData.pageNum,"show-elevator":""},on:{"on-change":_vm.chagepage}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13b0c875","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/device/list.vue
// module id = null
// module chunks = 